import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import EventEmitter, {
  SHOW_POPUP_CONFIRMATION_BUY_NOW_ADD_CART,
} from '../../../helpers/EventEmitter'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../utils/authorization'
import { CURRENCY, UNIT } from '../../../utils/currency'
import useGetUserSettingWithPreference from '../../category/useGetUserSettingWithPreference'
import { SCREEN } from '../../selectCurrencyUnit/constant'
import { selectAllowSetDefaultUnit } from '../../selectCurrencyUnit/slice'
import { useFormatCurrency } from '../../selectCurrencyUnit/useFormatCurrency'
import { changeData } from '../popup/popupConfirmationBuyNowOrAddCart/store/slice'

export const AddToCart = ({
  children,
  data,
  isFactSheet,
  reportName,
  isFromLibrary,
}) => {
  const dispatch = useDispatch()

  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)
  const { userSettings } = useGetUserSettingWithPreference(true)
  const isCalculatedDefaultUnitFS = useSelector(
    selectAllowSetDefaultUnit(SCREEN.FINANCIAL_STATEMENT),
  )
  const { currency: currencyFS, multiplier: multiplierFS } = useFormatCurrency(
    SCREEN.FINANCIAL_STATEMENT,
  )

  const isDefaultCurrencyByFS =
    !isCalculatedDefaultUnitFS &&
    AUTHORIZATION_API.cartAndOrders.defaultCurrencyByFS[userType.userTypeId] ===
      AUTHORIZATION_TYPE.ALLOW

  const handleAddToCart = (isAddCart, dataCart) => {
    dispatch(
      changeData({
        isAddCart,
        isFactSheet,
        reportName,
        isFromLibrary,
        data: dataCart ? dataCart : data,
        currencyCode: isFactSheet
          ? isDefaultCurrencyByFS
            ? currencyFS
            : userSettings.currency
          : CURRENCY.VND,
        currencyUnit:
          isFactSheet && isDefaultCurrencyByFS
            ? multiplierFS
            : UNIT.SINGLE.multiplier,
      }),
    )
    EventEmitter.dispatch(SHOW_POPUP_CONFIRMATION_BUY_NOW_ADD_CART)
  }

  return children(handleAddToCart)
}

AddToCart.propTypes = {
  children: PropTypes.func.isRequired,
  data: PropTypes.array,
}

AddToCart.defaultProps = {
  data: [],
}
